export const ALL_AGENTS_PATH = "/all-agents";
export const GLOBAL_REPORTS_PATH = "/reports";
export const DEFAULT_PATH = GLOBAL_REPORTS_PATH;
export const DIALO_PATH = "/calls";
export const CYG_ROOT_PATH = "/create-genie";

export const BULK_BROADCAST_ROOT_PATH = "/bulk-broadcast";
export const CREATE_BULK_BROADCAST_PATH = `${BULK_BROADCAST_ROOT_PATH}/create`;
export const ALL_BULK_BROADCASTS_PATH = `${BULK_BROADCAST_ROOT_PATH}/all`;
export const TEST_BULK_BROADCAST_PATH = `${BULK_BROADCAST_ROOT_PATH}/test`;

export const CREATE_NEW_AGENT_PATH = `${CYG_ROOT_PATH}/null/0`;

export const CREATE_DIALO_CAMPAIGN_PATH = "/create-campaign";
export const ALL_DIALO_CAMPAIGNS_PATH = "/all-campaigns";

export const CHAT_PATH = "/chat/[agentId]/[sessionId]";
export const TEST_ROOT_PATH = "/test";
export const TEST_RESULT_PATH = `${TEST_ROOT_PATH}/result/[...resultParams]`;
export const TEST_MONITOR_PATH = `${TEST_ROOT_PATH}/monitor/[...monitorParams]`;
export const IFRAME_PATH = "/iframe/[[...iframe]]";
export const CHATBOT_PATH = "/chatbot";
export const CP_DASHBOARD_PATH = "/cp-dashboard";
export const DIALO_CALL_LOGS = "/call-logs";

export const CALL_AUDITING_ROOT_PATH = "/call-auditing";
export const CALL_AUDITING_AGENT_WISE_REPORT_PATH = `${CALL_AUDITING_ROOT_PATH}/agent`;
export const CALL_AUDITING_ASSIGNMENT_WISE_REPORT_PATH = `${CALL_AUDITING_ROOT_PATH}/assignment`;
export const CALL_AUDITING_CALL_WISE_REPORT_PATH = `${CALL_AUDITING_ROOT_PATH}/call`;
